export default "__VITE_ASSET__DfFZ3JU4__"